import React from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from 'react-router-dom'

class StudentEmailVerify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            token: '',
            email: '',
            messageToDisplay: "Please Wait !!!"
        };

    }

    componentDidMount() {
        this.verifyTokenAndEmail();
    }

    verifyTokenAndEmail = () => {
        const queryString = require('query-string');
        var parsed = queryString.parse(this.props.location.search);
        this.setState({
            token: parsed.token,
            email: parsed.email
        });
        const headers = {
            "Content-Type": "application/json",
        };
        let url = `http://15.206.132.121:3002/api/verifyEmailToken?email=${parsed.email}&token=${parsed.token}`;
        fetch(url, { headers })
            .then(response => response.json())
            .then(data => {
                if (!data.success) {
                    throw data.message
                }
                this.setState({
                    messageToDisplay: data.data,
                    isVerified: true
                });
            })
            .catch(err => {
                toast.error(err, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
    }


    render() {
        return (
            <div className="container">
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <div className="alert alert-info" role="alert" style={{ textAlign: "center", marginTop: "20px" }}>
                    <strong>{this.state.messageToDisplay}   </strong>
                    <br />
                    {this.state.isVerified ? <span> <Link to={{ pathname: "/" }}> Click Here to Sign in</Link></span> : ""}
                </div> </div>
        );
    }
}

const connectedEmailVerify = connect()(StudentEmailVerify);
export { connectedEmailVerify as StudentEmailVerify };